<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";
import { Loading } from "element-ui";
import Vuex from "vuex";
export default {
  name: "App",
  created() {
    ///////////////////////////////

    //// DESARROLLO -> D
    //// PRODUCCION -> P
    //// CARTADEV   -> S (o cualquier otra letra)

    const entorno = "P";

    //const entorno = "D";
    ///////////////////////////////
    const isProd = process.env.NODE_ENV === "production";
    let apiUrl = "";
    switch (entorno) {
      case "P":
        apiUrl = "../api/public/index.php/";
        break;
      case "D":
        apiUrl = "http://localhost:8082/"; //http://46.136.51.106:1092/
        //apiUrl = "https://dev.numier.com/api/public/index.php"; //http://46.136.51.106:1092/
        break;
      default:
        apiUrl = "../api/public/index.php/";
        //apiUrl = "http://localhost:8082/";
        break;
    }
    //const apiUrl = isProd ? '../apidev/public/index.php/' : 'http://192.168.1.29:8082/';
    this.$store.dispatch("setApiUrl", apiUrl);
    this.$store.commit("changeEntorno", entorno);
    this.$store.commit("changeEsSelfi", true);
    
    this.changeApiUrl(apiUrl);

    let vm = this;

    this.axios.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        console.log(err);
        const originalConfig = err.config;
        if (err.response.status === 401 && err.response.data.logout) {
          console.error(err.response.data.message);
          vm.loading = Loading.service({ text: "Cargando..." });
          vm.loading.close();
          vm.logout();
          return Promise.resolve();
        }
        return Promise.reject(err);
      }
    );


    if (this.$cookie.get("jwt")) {
      this.$store.dispatch("setJWT", this.$cookie.get("jwt"));


      this.changeJwt(this.$cookie.get("jwt"));
      // Actuliazo la cookie del JWT si esta disponible
      var date = new Date();
      date.setDate(date.getDate() + 21);
      this.$cookie.set("jwt", this.$cookie.get("jwt"), { expires: date });

      if(this.$cookies.isKey("esSelfi")){
        this.cargarSelfi();
      }else{
        this.$cookies.remove("esSelfi");
      }

      if (this.$cookies.isKey("sectores")) {
        this.cargarSectores();
      } else {
        this.$cookies.remove("sectores");
      }
    }

    //this.cargarBusiness();
    // this.getHora();
    //this.terms();
    // this.$router.push("/terms");
  },
  mounted() {
    if (this.$route.name !== "turnos-operarios-external-link") {
      this.cargarBusiness();
      this.getPerfil();
    }
  },
  computed: {
    ...Vuex.mapState([
      "xidTpv",
      "xidBusiness",
      "xlistBusiness",
      "listaSectores",
      "xlistTpv",
      "xlistIdsTpv",
      "xlistIdsTpvFiltro",
      "xFechaDesde",
      "xFechaHasta",
      "xRespuesta",
      "xjwt",
      "xapiUrl",
    ]),

    jwt() {
      return this.$store.getters.jwt;
    },
  },
  data() {
    return {
      email: "",
      loading: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("setJWT", "");
      this.$store.dispatch("setBusiness", "");
      this.$store.dispatch("setDateTo", "");
      this.$store.dispatch("setDateFrom", "");

      this.$cookie.delete("jwt");

      if (Vue.$cookies.isKey("sectores")) {
        this.changeSectores(false);
        this.changeListaSectores([]);
        Vue.$cookies.remove("sectores");
        Vue.$cookies.remove("filtroSector");
      }

      Vue.$cookies.remove("language");

      this.$router.push("/login");
    },
    getPerfil() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getPerfilBasico", config)
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result.perfil == false) {
              vm.logout();
            } else {
              vm.changeUser(response.data.result.perfil);
            }
          } else {
            vm.logout();
            /*swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });*/
          }
        });
    },
    ...Vuex.mapMutations([
      "changeJwt",
      "changeEsSelfi",
      "changeApiUrl",
      "changeUser",
      "changeSectores",
      "changeListaSectores",
    ]),

    ...Vuex.mapActions(["cargarBusiness", "cargarSectores", "cargarSelfi"]),
  },
};
</script>

<style>
.theme-numier .vdatetime-popup__header,
.theme-numier .vdatetime-calendar__month__day--selected > span > span,
.theme-numier .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #1E22AA;
}

.theme-numier .vdatetime-year-picker__item--selected,
.theme-numier .vdatetime-time-picker__item--selected,
.theme-numier .vdatetime-popup__actions__button {
  color: #1E22AA;
}

.el-scrollbar__view {
  border: 1px solid #ababab !important;
}

.vue-tabs .nav > li span.title {
  color: #447df7;
}

.tituloNumier {
  font-size: 25px;
  color: #1E22AA;
  margin-top: 0px;
  font-weight: bold;
  font-family: "Numier", "Roboto";
}

i {
  cursor: pointer;
}

i {
  cursor: pointer;
}

table {
  font-size: 0.9em;
}

.tab-content {
  margin-top: 20px;
}

.imgCam img {
  height: 189px !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue